var styles = {
  "Paragraph": "Online-Store-UI-Paragraph_jv8i5"
};

export { styles as default };
